import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col, Button,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {RiUserAddLine} from "react-icons/ri";
import {SeoHelper} from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class HowToRegisterHelp extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);

    // sessionStorage.removeItem("customer");
  }

  stepsData = [
    {
      title: "How to register",
      description: "At the end of this guide you will be able to:<br/><br/> " +
          "<img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
          "successfully register an account on The Worship Bible"
    },
    {
      title: "Access the Registration Page",
      description: "Click the <a href='/register/choose-your-plan'><b><svg stroke=\"currentColor\" fill=\"currentColor\" stroke-width=\"0\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z\"></path></svg>Register</b></a> button on the navigation bar",
    },
    {
      title: "Choose your plan",
      description: "On this page you will see four options. Choose the one that best fits how you and your team plan worship:" +
          "<br/><br/><b>Monthly Plan</b> — full access to all features, billed monthly at £6.50 per month. Cancel at any time with no long-term commitment." +
          "<br/><br/><b>Annual Plan</b> — full access to all features, billed annually at £60 per year. This saves you over 20% compared to the monthly plan and is ideal if you plan to use The Worship Bible consistently throughout the year." +
          "<br/><br/><b>Group Annual</b> — everything in the individual plans, plus shared access for up to 10 members. Billed annually at £300 per year. Built for small churches and music teams who plan worship collaboratively." +
          "<br/><br/><b>Organisation</b> — unlimited seats with a £500 per year administration fee plus £1.67 per active seat per month. Designed for dioceses, denominations, and institutions coordinating worship across multiple teams." +
          "<br/><br/>Consider your team size and how often you plan services when making your choice. Click <b>Get started</b> or <b>Register</b> under your chosen plan to continue.",
      image: "/help-images/how-to-register/choose-your-plan.png",
    },
    {
      title: "Registration",
      description: "To complete your registration, fill in your first and last name, provide a valid email address, create and confirm a secure password, and confirm that you agree to the Privacy Policy. After entering all required information, click <b>Register</b> to move to the <b>Billing</b> details page." +
          "<br/><br/>" +
          "The password must be at least 8 characters long." +
          "<br/><br/>" +
          "A confirmation email will be sent to the email address you provide.",
      image: "/help-images/how-to-register/registration-form.png",
    },
    {
      title: "Billing",
      description: "Provide your payment information — either by entering your card details (card number, expiry date, security code, and billing address) or by choosing PayPal — click <b>Set Up Subscription</b> to finalise your subscription registration.",
      image: "/help-images/how-to-register/billing-payment.png",
    },
    {
      title: "Registration confirmation",
      description: "Congratulations, you have now completed all the steps to sign up for a subscription to The Worship Bible.",
      image: "/help-images/how-to-register/registration-complete.png",
    },
    {
      title: "What's next",
      description: "Click <a href='/sign-in'><svg stroke=\"currentColor\" fill=\"currentColor\" stroke-width=\"0\" viewBox=\"0 0 24 24\" color=\"#5e72e4\" class=\"mr-2\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"color: rgb(94, 114, 228);\"><path d=\"M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z\"></path></svg>Sign In</a> and start building unlimited worship song-flows.  " +
          "<br/></br><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> Need help signing in, check out the <a href='/help/how-to-sign-in'>helpful article</a>" +
          "<br/><br/>" +
          "Or view our other <a href='/help'><svg stroke=\"currentColor\" fill=\"currentColor\" stroke-width=\"0\" viewBox=\"0 0 24 24\" color=\"#5e72e4\" class=\"mr-2\" height=\"36\" width=\"36\" xmlns=\"http://www.w3.org/2000/svg\" style=\"color: rgb(94, 114, 228);\"><path d=\"M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z\"></path></svg>help articles</a> for more guidance.",
      image: "/help-images/well-done.png",
      enlargeable: false
    }
  ];


  render() {
    return (
      <>
        <SeoHelper
            uri="/help/how-to-register"
            title = "How to register | Help | The Worship Bible"
            description={"Get help registering your account."}
        />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>help</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          <Row className="mt-3">
                            <Col>
                              <div className="d-flex align-items-center mb-3">
                                <RiUserAddLine color="#5e72e4" size="24" className="mr-2"/>
                                <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">How to register</h2>
                              </div>
                            </Col>
                            <Col md="3" xs="12">
                              <Button
                                  block
                                  type="submit"
                                  className="mb-2"
                                  color="white"
                                  href="/help"
                              >
                                <span className="btn-inner--text">Back to help</span>
                              </Button>
                            </Col>
                          </Row>
                          <InstructionsWizard stepsData={this.stepsData} />
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default HowToRegisterHelp;
